<template>
  <div class="nav-wrapper">
    <!--<app-topnotice ref="topnotice"></app-topnotice>-->
    <nav class="navbar navbar-expand navbar-dark mai-top-header">
      <div class="container">
        <div class="navbar-brand">
          <button
            type="button"
            data-toggle="collapse"
            data-target="#main-navbar"
            aria-controls="#main-navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
            class="navbar-toggler hidden-md-up collapsed"
            style="color: black; outline: none; padding-left: 0; padding-right: 0.5rem; font-size: 1.5rem;"
          >
            <i class="fal fa-bars"></i>
          </button>
          <img class="icon" :src="logo" alt="" />
          <span class="logo-title" style="color: black !important"
            >Maprint</span
          >
        </div>
        <ul class="nav navbar-nav float-lg-left mai-user-nav" v-if="ref.id">
          <li id="reload-button" class="nav-item">
            <span
              class="icon s7-refresh refresh nav-link"
              v-bind:class="{ refreshed: isRefreshed }"
              :title="t('Reload Data')"
              v-on:click="refresh"
            ></span>
          </li>
          <li class="dropdown nav-item">
            <a
              href="javascript:void(0)"
              data-toggle="dropdown"
              role="button"
              aria-expanded="false"
              class="dropdown-toggle nav-link"
            >
              <span class="user-name">{{ user.name }}</span>
              <span class="angle-down s7-angle-down"></span>
            </a>
            <div role="menu" class="dropdown-menu">
              <a
                href="javascript:void(0)"
                class="dropdown-item"
                section="settings"
              >
                <span class="icon s7-tools"> </span>{{ t("settings") }}</a
              >
              <a
                href="javascript:void(0)"
                class="dropdown-item logout-item"
                v-on:click="logout"
              >
                <span class="icon s7-power"> </span>{{ t("logout") }}</a
              >
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <app-subheader></app-subheader>
  </div>
</template>

<script>
import TopNotice from "./TopNotice.vue";
import SubHeader from "./SubHeader.vue";

import logo from "../assets/img/logo.png";
import { mapState } from "vuex";

export default {
  data() {
    return {
      logo: logo,
      isRefreshed: true
    };
  },
  computed: {
    ...mapState({
      user: state => state.user.data,
      ref: state => state.user.ref
    })
  },
  methods: {
    logout: function() {
      this.$root.$emit("user-logout");
    },
    refresh: function() {
      this.isRefreshed = true;
      this.$root.$children[0].$refs.auth.fetchAll();
    }
  },
  mounted() {
    window.refresh = this.refresh;
  },
  components: {
    "app-topnotice": TopNotice,
    "app-subheader": SubHeader
  }
};
</script>
<style lang="scss" scoped>
@import "../style/scss/variables/colors";
.mai-top-header {
  border: 0;
  margin-bottom: 0;
  background-color: transparent;
  padding: 0;
  height: 40px;
  margin: 10px 0px;
  > .container {
    padding: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    .refresh {
      color: $dark-font-color;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .dropdown-toggle:after {
    display: none;
  }
  .dropdown-menu {
    margin-top: 0;
  }
  .navbar-brand {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    color: $dark-font-color;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 50px;
    height: 50px;
    width: 133px;
    background-repeat: no-repeat;
    background-position: 0 center;
    margin-right: 45px;
  }
  .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    > .nav-item {
      > .nav-link {
        line-height: 49px;
        font-family: Raleway, sans-serif;
        font-size: 1.077rem;
        padding: 0;
        outline: 0;
        &:hover {
          color: #099bc3;
        }
        &.refresh {
          font-size: 20px;
          transition: transform 0.5s ease-in-out;
          &:hover:not(.refreshed) {
            transform: rotate(360deg);
          }
          @keyframes rotate {
            to {
              transform: rotate(360deg);
            }
          }
          &.refreshed {
            animation: rotate 1.5s linear infinite;
          }
        }
      }
      &.dropdown {
        > a .angle-down {
          position: relative;
          font-size: 2.077rem;
          vertical-align: middle;
          width: 27px;
          display: inline-block;
          line-height: inherit;
        }
        .dropdown-menu {
          border: 0;
          border-radius: 6px;
          -webkit-box-shadow: none;
          box-shadow: none;
          background-color: #002731;
          min-width: 184px;
          > .dropdown-item {
            text-transform: capitalize;
            font-size: 1rem;
            color: #adadad;
            padding: 9px 20px;
            min-width: 175px;
            font-family: Raleway, sans-serif;
            &:hover {
              background-color: #000000;
              color: $color-background;
            }
            &:focus {
              background-color: transparent;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 767.9px) {
  .nav-wrapper {
    width: 100%;
    .navbar-toggler {
      display: inline-block;
    }
    .logo-title {
      display: none;
    }
    .mai-top-header {
      .navbar-nav {
        padding-right: 7px;
        & > .nav-item > .nav-link {
          line-height: 50px;
        }
        &.mai-user-nav {
          -webkit-box-ordinal-group: 2;
          -webkit-order: 1;
          -ms-flex-order: 1;
          order: 1;
          > .nav-item.dropdown > .nav-link {
            .user-name {
              -webkit-box-flex: 1;
              -webkit-flex: 1 1 100%;
              -ms-flex: 1 1 100%;
              flex: 1 1 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: right;
              max-width: 30vw;
            }
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
          }
        }
      }
      .navbar-brand {
        padding-left: 13px;
        margin-right: 20px;
      }
      .mai-icons-nav {
        > .nav-item.dropdown.show {
          &:hover > a .icon,
          > a .icon {
            color: $color-background;
          }
        }
        .mai-messages > .dropdown-menu,
        .mai-notifications > .dropdown-menu,
        .mai-settings > .dropdown-menu {
          right: 0;
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopHeader.vue